<template>
    <div class="ur-data-grid__header__wrapper" ref="scrollHeader" :style="wrapperStyle">
        <div class="ur-data-grid__header__wrapper__position-adjust" :style="adjustStyle">
            <slot>
                <check-cell v-if="!freezeWidth && gridInfo.opts.selectCheck"/>
                <header-cell :field="f" v-for="(f,idx) in gridInfo.dataCols" :key="f.value+'_'+idx"/>
                <header-cell :width="accordWidth"
                    v-if="gridInfo.opts.accordion && !gridInfo.vars_freezeWidth"/>
            </slot>
        </div>
    </div>
</template>

<script>
import headerCell from "./urDataGridHeaderCell";
import checkCell  from "./urDataGridHeaderCheckCell";

export default {
    name : 'urDataGridHeaderRow',
    inject : ['gridInfo'],
    components : {headerCell, checkCell},
    props: {rowCnt : {type:Number, default:1}},
    computed: {
        freezeWidth() {return this.gridInfo.vars_freezeWidth},
        accordWidth() {
            var width = this.gridInfo.opts.accordionColumnWidth;
            if(!this.gridInfo.vars_freezeWidth) width += 10;// @see accordionCell.vue add 10px
            return width;
        },
        wrapperStyle() {
            var height = this.gridInfo.opts.headerHeight;
            if(this.rowCnt) height *= this.rowCnt;
            height+=2; // for border top/bot
            return {
                "height": `${height}px`,
                "width" : `calc(100% - ${this.freezeWidth}px)`,
                "margin-left": `${this.freezeWidth}px`
            }
        },
        adjustStyle() {return {
            // XXX + 1px : 헤더를 바꾸니 자꾸 소숫점으로 뜨는데.. 
            'width' : (this.gridInfo.vars_tableWidth-this.freezeWidth+1)+'px'
        }}
    },
    mounted() {
        this.gridInfo.func.setRefs('scrollHeader',this.$refs.scrollHeader);
    },
}
</script>